import { Popover } from "@/components/Popover"
import { ReactComponent as CloseIcon } from "@/Images/icons/Close.svg"
import { ReactComponent as LoadingIcon } from "@/Images/icons/Loading.svg"
import { Placement } from "@floating-ui/react"
import { ITransactionInfo } from "@usher/pe-client-front-end-lib/dist/ExClient"
import clsx from "clsx"
import type { FC, PropsWithChildren } from "react"
import { memo } from "react"

type Props = {
  title: string
  placement?: Placement
  isLoading: boolean
  isPayout?: boolean
  info: ITransactionInfo | null
  onOpen: () => void
}

const TransactionInfoBaseComponent: FC<PropsWithChildren<Props>> = ({ onOpen, title, children, placement, info, isLoading, isPayout = false }) => (
  <Popover className="flex flex-col transaction-info-popover" target={children} placement={placement} onOpen={onOpen}>
    {(close) => (
      <div className="max-h-full flex flex-col overflow-auto">
        <div className="flex items-center w-full justify-between border-b border-[#f0f5f9]">
          <div className="view-hover_tilte">{title}</div>
          <div onClick={close} className="mr-3 cursor-pointer p-2">
            <CloseIcon />
          </div>
        </div>
        <div className="view-hover_body overflow-auto flex-[1_1_0]">
          {isLoading ? (
            <div className="w-full py-2 text-[14px] flex items-center gap-2 justify-center">
              <LoadingIcon className="animate-spin" />
              Loading
            </div>
          ) : (
            <>
              <div className="view-hover_item">
                <div className="view-hover_lavel">Transaction ID:</div>
                <div className="view-hover_value">{info?.id}</div>
              </div>
              <div className="view-hover_item">
                <div className="view-hover_lavel">Card number:</div>
                <div className="view-hover_value">{info?.maskedCardNumber}</div>
              </div>
              <div className="view-hover_item view-hover_item--short">
                <div className="view-hover_lavel">Amount:</div>
                <div className="view-hover_value">
                  <span
                    className={clsx({
                      "text-red-500": isPayout ? info?.status?.toLowerCase?.()?.includes("decline") : (info?.amount ?? 0) < 0,
                      "text-green-500": isPayout ? info?.status?.toLowerCase?.()?.includes("process") : (info?.amount ?? 0) >= 0,
                    })}
                  >
                    {Number(info?.amount ?? "0").toFixed(2)}
                  </span>{" "}
                  {info?.currency}
                </div>
              </div>
              {Number(info?.fee || 0) > 0 && (
                <div className="view-hover_item">
                  <div className="view-hover_lavel">Fee:</div>
                  <div className="view-hover_value wrap">
                    {/*@ts-ignore*/}
                    {Number(Number(info?.fee || 0) + Number(info?.fee_fx || 0) + Number(info?.fee_pay || 0)).toFixed(2)} {info?.currency}
                  </div>
                </div>
              )}
              <div className="view-hover_item">
                <div className="view-hover_lavel">Source:</div>
                <div className="view-hover_value wrap">{info?.source ?? ""}</div>
              </div>
              <div className="view-hover_item">
                <div className="view-hover_lavel">Status:</div>
                <div
                  className={clsx("view-hover_value", {
                    "text-red-500": isPayout ? info?.status?.toLowerCase?.()?.includes("decline") : false,
                    "text-green-500": isPayout ? info?.status?.toLowerCase?.()?.includes("process") : false,
                  })}
                >
                  {info?.status}
                </div>
              </div>
              <div className="view-hover_item">
                <div className="view-hover_lavel">Note:</div>
                <div className="view-hover_value">
                  <span className="grey">{info?.info}</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    )}
  </Popover>
)

export const TransactionInfoBase = memo(TransactionInfoBaseComponent)
